$(document).on('submit','.dnJs-form-ajax', function(e){
    e.preventDefault();

    var form = $(this);
    var url = form.attr('action');
    var toReplace = $(this).data('to-replace').split(',');

    var buttons = form.find('button');

    var enableLoadingButton = function() {
        buttons.each(function() {
            if ($(this).attr('type') === 'submit') {
                $(this).enableLoadingAnimation(true);
            }
        });
    };

    var disableLoadingButton = function() {
        buttons.each(function() {
            if ($(this).attr('type') === 'submit') {
                $(this).enableLoadingAnimation(false);
            }
        });
    };

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        beforeSend: function(){
            enableLoadingButton();
        },
        success: function (response) {
            toReplace.forEach(function (replaceClass) {
                var newForm = $(replaceClass, response);
                if (newForm.length) {
                    $(replaceClass).replaceWith(newForm);
                }
            });
        },
        complete: function() {
            $(document).trigger('loaded.form.ajax', form);
            disableLoadingButton();
        },
        error: function() {
            disableLoadingButton();
        }
    });
});

$(document).on('loaded.form.ajax', function (e, form) {

    var form = $(form);
    var scrollToElement = form.attr('data-scroll-to');

    if (form.length && typeof scrollToElement !== typeof undefined && scrollToElement !== false) {
        if ($(scrollToElement).length) {
            document.querySelector(scrollToElement).scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }
});